import { ObdService } from './../../../services/obd.service';
import { Component, OnInit } from '@angular/core';
import { faHome,faCar,faSync,faDesktop } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { VehicleLocationModel } from 'src/app/models/OBD/VehicleLocationModel';
import { FuelConsumptionModel } from 'src/app/models/OBD/FuelConsumptionModel';
import { VehicleMileageModel } from 'src/app/models/OBD/VehicleMileageModel';
import { FuelLevelModel } from 'src/app/models/OBD/FuelLevelModel';
import { ControlModuleVoltageModel } from 'src/app/models/OBD/ControlModuleVoltageModel';
import { VehicleEngineStatusModel } from 'src/app/models/OBD/VehicleEngineStatusModel';
import { EngineCoolantTemperatureModel } from 'src/app/models/OBD/EngineCoolantTemperatureModel';
import { SpeedModel } from 'src/app/models/OBD/SpeedModel';
import { RpmModel } from 'src/app/models/OBD/RpmModel';
import { LowBatteryModel } from 'src/app/models/OBD/LowBatteryModel';

@Component({
  selector: 'app-obd-details',
  templateUrl: './obd-details.component.html',
  styleUrls: ['./obd-details.component.scss']
})
export class ObdDetailsComponent implements OnInit {

  faHome = faHome;
  faCar = faCar;
  faSync = faSync;
  cardLoader1 = false;
  cardLoader2 = false;
  cardLoader3 = false;
  cardLoader4 = false;
  cardLoader5 = false;
  cardLoader6 = false;
  cardLoader7 = false;
  cardLoader8 = false;
  cardLoader9 = false;
  cardLoader10 = false;

  deviceId;
  lang = 'en';
  vehicleLocationModel?: VehicleLocationModel ={};
  fuelConsumptionModel?: FuelConsumptionModel ={};
  vehicleMileageModel?: VehicleMileageModel ={};
  fuelLevelModel?: FuelLevelModel ={};
  controlModuleVoltageModel?: ControlModuleVoltageModel ={};
  vehicleEngineStatusModel?: VehicleEngineStatusModel ={};
  engineCoolantTemperatureModel?: EngineCoolantTemperatureModel ={};
  speedModel?: SpeedModel ={};
  rpmModel?: RpmModel ={};
  lowBatteryModel?: LowBatteryModel ={};



  constructor(
    private router: Router,
    private obdService: ObdService,
    private route: ActivatedRoute,
  ) { }


  ngOnInit() {


    this.deviceId = this.route.snapshot.params.deviceID;

    this.GetVehicleLocation();
    this.GetFuelConsumption();
    this.GetVehicleMileage();

    this.GetFuelLevel();
    this.GetControlModuleVoltage();
    this.GetVehicleEngineStatus();

    this.GetEngineCoolantTemperature();
    this.GetSpeed();
    this.GetRpm();

    this.GetLowBattery();

  }

  public GetVehicleLocation(){
    this.obdService.GetVehicleLocation(this.deviceId)
    .subscribe(res => {
      this.vehicleLocationModel = res;
      this.cardLoader1 = false;
    });
  }

  public GetFuelConsumption(){
    this.obdService.GetFuelConsumption(this.deviceId)
    .subscribe(res => {
      this.fuelConsumptionModel = res;
      this.cardLoader2 = false;
    });
  }

  public GetVehicleMileage(){
    this.obdService.GetVehicleMileage(this.deviceId)
    .subscribe(res => {
      this.vehicleMileageModel = res;
      this.cardLoader3 = false;
    });
  }

  public GetFuelLevel(){
    this.obdService.GetFuelLevel(this.deviceId)
    .subscribe(res => {
      this.fuelLevelModel = res;
      this.cardLoader4 = false;
    });
  }

  public GetControlModuleVoltage(){
    this.obdService.GetControlModuleVoltage(this.deviceId)
    .subscribe(res => {
      this.controlModuleVoltageModel = res;
      this.cardLoader5 = false;
    });
  }

  public GetVehicleEngineStatus(){
    this.obdService.GetVehicleEngineStatus(this.deviceId)
    .subscribe(res => {
      this.vehicleEngineStatusModel = res;
      this.cardLoader6 = false;
    });
  }

  public GetEngineCoolantTemperature(){
    this.obdService.GetEngineCoolantTemperature(this.deviceId)
    .subscribe(res => {
      this.engineCoolantTemperatureModel = res;
      this.cardLoader7 = false;
    });
  }

  public GetSpeed(){
    this.obdService.GetSpeed(this.deviceId)
    .subscribe(res => {
      this.speedModel = res;
      this.cardLoader8 = false;
    });
  }

  public GetRpm(){
    this.obdService.GetRpm(this.deviceId)
    .subscribe(res => {
      this.rpmModel = res;
      this.cardLoader9 = false;
    });
  }

  public GetLowBattery(){
    this.obdService.GetLowBattery(this.deviceId)
    .subscribe(res => {
      this.lowBatteryModel = res;
      this.cardLoader10 = false;
    });
  }


  refreshVehicleLocation(){
    this.cardLoader1 = true;
    this.GetVehicleLocation();
  }

  refreshFuelConsumption(){
    this.cardLoader2 = true;
    this.GetFuelConsumption();
  }

  refreshVehicleMileage(){
    this.cardLoader3 = true;
    this.GetVehicleMileage();
  }

  refreshFuelLevel(){
    this.cardLoader4 = true;
    this.GetFuelLevel();
  }

  refreshControlModuleVoltage(){
    this.cardLoader5 = true;
    this.GetControlModuleVoltage();
  }

  refreshVehicleEngineStatus(){
    this.cardLoader6 = true;
    this.GetVehicleEngineStatus();
  }

  refreshEngineCoolantTemperature(){
    this.cardLoader7 = true;
    this.GetEngineCoolantTemperature();
  }

  refreshSpeed(){
    this.cardLoader8 = true;
    this.GetSpeed();
  }

  refreshRpm(){
    this.cardLoader9 = true;
    this.GetRpm();
  }

  refreshLowBattery(){
    this.cardLoader10 = true;
    this.GetLowBattery();
  }



}
